import z from "zod";
import { driverSchema } from "./driverSchema";
import { guestSchema } from "./guestSchema";

export const eventRegistrationSchema = z.object({
  family_members: z.array(z.string()).optional(),
  drivers: z.array(driverSchema).optional(),
  children: z.array(z.string()).optional(),
  guests: z.array(guestSchema).optional(),
});

export type EventFormData = z.infer<typeof eventRegistrationSchema>;
